

$(window).on("load", function () {
	var $profileSection = $("#nth-ld-t4-profile");

	if (!$profileSection.length) {
		return;
	}

	var $profileBlock = $profileSection.find(".profile");
	var $triggerUpload = $profileBlock.find("a");
	var $profileImage = $profileBlock.find("img");
	var $uploadInput = $profileBlock.find(".profile-upload-input");
	var currentPreviewUrl = "";

	if (!$triggerUpload.length || !$profileImage.length || !$uploadInput.length) {
		return;
	}

	$triggerUpload.on("click", function (event) {
		event.preventDefault();
		$uploadInput.trigger("click");
	});

	$uploadInput.on("change", function () {
		var file = this.files && this.files[0];

		if (!file) {
			return;
		}

		if (!file.type || file.type.indexOf("image/") !== 0) {
			$uploadInput.val("");
			return;
		}

		if (currentPreviewUrl) {
			URL.revokeObjectURL(currentPreviewUrl);
		}

		currentPreviewUrl = URL.createObjectURL(file);
		$profileImage.attr("src", currentPreviewUrl);
	});

	$(window).on("beforeunload", function () {
		if (currentPreviewUrl) {
			URL.revokeObjectURL(currentPreviewUrl);
		}
	});
});
